import moment from 'moment-timezone'

/**
 * RM's compact member-facing relative time — the Booked rows' "Booked 3h ago" convention
 * (RestaurantGridCard `timeSinceBooked`): 45m, 3h, 2d, 4mo, 1yr. Empty string when there's no date.
 */
export function relativeAgo(date, now = moment()) {
  if (!date) return ''
  const then = moment(date)
  if (!then.isValid()) return ''
  const minutes = Math.max(now.diff(then, 'minutes'), 0)
  if (minutes < 60) return `${minutes}m`
  const hours = now.diff(then, 'hours')
  if (hours < 24) return `${hours}h`
  const days = now.diff(then, 'days')
  if (days <= 30) return `${days}d`
  const months = now.diff(then, 'months')
  if (months <= 11) return `${months}mo`

  return `${now.diff(then, 'years')}yr`
}
